import { mapState } from 'vuex';
import Lokakarya2024 from './Lokakarya2024';
import LokakaryaA1A2 from './LokakaryaA1A2';
import LokakaryaA3 from './LokakaryaA3';
import RefleksiCoaching from './RefleksiCoaching';
import RefleksiLokakarya from './RefleksiLokakarya';

export default {
  mixins: [Lokakarya2024, LokakaryaA1A2, LokakaryaA3, RefleksiCoaching, RefleksiLokakarya],
  computed: {
    ...mapState('preferensi', {
      ptk: (state) => state.data?.ptk ?? {},
    }),

    ...mapState('lokakaryaPa', {
      mInstrumen: (state) => state.instrumen || {},
    }),

    mJenjang() {
      return [
        { text: 'TK-PAUD', value: 1 },
        { text: 'SD', value: 2 },
        { text: 'SMP', value: 3 },
        { text: 'SMA', value: 4 },
        { text: 'SLB', value: 6 },
      ];
    },

    configs() {
      const M_PROPINSI = this.masters.propinsi || {};
      const M_KOTA = this.masters.kota || {};
      return {
        selector: ['k_propinsi', 'k_kota'],
        required: ['k_propinsi', 'k_kota'],
        label: ['Provinsi', 'Kabupaten/Kota'],
        options: [M_PROPINSI, M_KOTA],
        grid: [{ cols: 6 }, { cols: 6 }],
      };
    },

    isNotEmpty() {
      return this.$isObject(this.initValue) && this.form.tgl_pelaksanaan;
    },

    mModaLokakarya() {
      let result = Object.assign({}, this.masters.lokakarya_moda_psp || {});
      delete result[3];

      return result;
    },

    schemaInstrumen() {
      return {
        lokakarya12: this.lokakaryaA1A2,
        'lokakarya12|sekolah12': this.lokakaryaA1A2,
        lokakarya3: this.lokakaryaA3,
        refleksi123: this.refleksiLokakarya,
        coaching123: this.refleksiCoaching,
        'coaching123|iht123': this.refleksiCoaching,
        'ds24-lokakarya': this.lokakarya2024,
        'ds24-lokakarya|ds24-pmo': this.lokakarya2024,
        'ds24-refleksi': this.lokakarya2024,
        'ds24-refleksi-ps': this.lokakarya2024,
      };
    },

    instrumens() {
      let result = {};

      for (const keyInstrumen in this.mInstrumen) {
        const instrumens = this.mInstrumen[keyInstrumen] || [];
        result[keyInstrumen] = [];

        for (const ins of instrumens) {
          const items = (ins.opsi || []).map((opsi) => {
            return {
              text: opsi.keterangan,
              value: opsi.k_lokakarya_opsi_psp,
              is_lain: opsi.is_lain,
              validator: opsi.validator,
            };
          });
          const othersValue = items.filter((item) => item.is_lain === 1);
          const otherValue = othersValue[0] || {};

          const validators = (ins.validator || '').split('|');
          let validator = {};
          for (const item of validators) {
            if (item) {
              const val = item.split(':');
              validator[val[0]] = val[1];
            }
          }

          let counter = false;
          if (validator.min_words) {
            counter = validator.min_words;
          } else if (othersValue.length) {
            counter = {};
            for (const val of othersValue) {
              const validators = (val.validator || '').split('|');
              let validator = {};
              for (const item of validators) {
                if (item) {
                  const val = item.split(':');
                  validator[val[0]] = val[1];
                }
              }

              counter[val.value] = validator.min_words || false;
            }
          }

          if (ins.tipe === 'checkbox') {
            result[keyInstrumen].push({
              id: (ins.k_lokakarya_instrumen_psp || '').toString(),
              type: 'Checkbox',
              name: `instrumen-checkbox-${ins.k_lokakarya_instrumen_psp}`,
              label: ins.keterangan,
              labelColor: 'indigo',
              items,
              hideDetails: true,
              row: true,
              singleLine: true,
              notitle: true,
              class: 'mb-0',
              grid: { cols: 12 },
              itemGrid: { cols: 12, lg: 4 },
              useOthers: true,
              othersValue: +otherValue.value,
              readonly: this.readOnly,
              others: {
                type: 'VTextarea',
                name: `input-lain-${ins.k_lokakarya_instrumen_psp}-${otherValue.value}`,
                label: 'Tuliskan jawaban lainnya',
                placeholder: 'Tuliskan jawaban lainnya',
                hint: 'wajib diisi',
                required: true,
                outlined: true,
                dense: true,
                singleLine: true,
                hideDetails: true,
                rows: 2,
                autoGrow: true,
                grid: { cols: 12, md: 6 },
              },
            });
          } else if (ins.tipe === 'radio') {
            let rowOption = [11, 51, 81, 83, 2021];
            let gridLg = [
              [2001, 2008],
              [2061, 2068],
              [2101, 2108],
            ];
            let newIdInsItem = [];

            const arrayValues = gridLg.filter((item) => Array.isArray(item));
            for (const itemArr of arrayValues) {
              for (let i = itemArr[0]; i <= itemArr[1]; i++) {
                newIdInsItem.push(i);
              }
            }

            gridLg = [...newIdInsItem, ...gridLg.filter((item) => !Array.isArray(item))];
            rowOption = [...rowOption, ...gridLg];

            result[keyInstrumen].push({
              id: (ins.k_lokakarya_instrumen_psp || '').toString(),
              type: 'VRadio',
              name: `instrumen-radio-${ins.k_lokakarya_instrumen_psp}`,
              label: ins.keterangan,
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              hint: 'wajib diisi',
              items,
              customClass: 'mt-0',
              hideDetails: true,
              outlined: true,
              dense: true,
              row: rowOption.includes(+ins.k_lokakarya_instrumen_psp),
              singleLine: false,
              grid: { cols: 12, md: 12 },
              gridLg: gridLg.includes(+ins.k_lokakarya_instrumen_psp) ? 2 : '',
              useOthers: true,
              othersValue: othersValue.map((val) => +val.value),
              readonly: this.readOnly,
              others: {
                type: 'VTextarea',
                name: `input-lain-${ins.k_lokakarya_instrumen_psp}-${otherValue.value}`,
                label: 'Tuliskan jawaban lainnya',
                placeholder: 'Tuliskan jawaban lainnya',
                hint: 'wajib diisi',
                required: true,
                outlined: true,
                dense: true,
                singleLine: true,
                hideDetails: true,
                rows: 2,
                autoGrow: true,
                grid: { cols: 12, md: 6 },
              },
            });
          } else if (ins.tipe === 'number') {
            result[keyInstrumen].push({
              id: (ins.k_lokakarya_instrumen_psp || '').toString(),
              type: 'VTextField',
              name: `instrumen-input-${ins.k_lokakarya_instrumen_psp}`,
              label: ins.keterangan,
              labelColor:
                this.isNotEmpty &&
                !this.form[`instrumen-input-${ins.k_lokakarya_instrumen_psp}`] &&
                this.form[`instrumen-input-${ins.k_lokakarya_instrumen_psp}`] !== 0
                  ? 'red'
                  : 'indigo',
              hint: '',
              mask: '#####',
              customClass: 'mt-0',
              placeholder: 'Tuliskan angka',
              outlined: true,
              singleLine: true,
              hideDetails: true,
              dense: true,
              readonly: this.readOnly,
              grid: { cols: 12, md: 6, sm: 12 },
            });
          } else if (ins.tipe === 'textarea') {
            result[keyInstrumen].push({
              id: (ins.k_lokakarya_instrumen_psp || '').toString(),
              type: 'VTextarea',
              name: `instrumen-input-${ins.k_lokakarya_instrumen_psp}`,
              label: ins.keterangan,
              labelColor: validator.min_words
                ? !!this.form[`instrumen-input-${ins.k_lokakarya_instrumen_psp}`] &&
                  this.$wordCount(this.form[`instrumen-input-${ins.k_lokakarya_instrumen_psp}`] || '') <
                    validator.min_words
                  ? 'red'
                  : 'indigo'
                : 'indigo',
              customClass: 'mt-0',
              placeholder: `Tuliskan jawaban ${validator.min_words ? `(minimal ${validator.min_words} kata)` : ''}`,
              hint: validator.min_words ? `Deskripsi minimal ${validator.min_words} kata` : '',
              required: false,
              outlined: true,
              singleLine: true,
              dense: true,
              readonly: this.readOnly,
              rows: 3,
              autoGrow: true,
              counter: true,
              counterValue: (v) => this.$wordCount(v),
              grid: { cols: 12, md: 12, sm: 12 },
            });
          } else if (ins.tipe === 'date') {
            result[keyInstrumen].push({
              id: (ins.k_lokakarya_instrumen_psp || '').toString(),
              type: 'VDatePicker',
              name: `instrumen-input-${ins.k_lokakarya_instrumen_psp}`,
              label: ins.keterangan,
              labelColor: 'indigo',
              usePrependInnerIcon: 'mdi-calendar-month',
              hint: 'wajib diisi',
              outlined: true,
              singleLine: true,
              disabled: this.readOnly,
              hideDetails: true,
              dense: true,
              grid: { cols: 12, md: 12, sm: 12 },
            });
          }
        }
      }

      return result;
    },

    lokakaryaBerkases() {
      return (
        this.$getDeepObj(this.detail, 'lokakarya.psp_kp_pa_lokakarya_berkases') ||
        this.$getDeepObj(this.detail, 'psp_kp_pa_lokakarya_berkases') ||
        []
      );
    },

    schema() {
      const mapSchema = {
        51: 'schemaOrientasi',
        52: 'schemaTingkatKota',
        53: 'schemaTingkatKota',
        54: 'schemaTingkatKota',
        55: 'schemaRefleksiCoaching',
        56: 'schemaRefleksiCoaching',
        57: 'schemaRefleksiCoaching',
        58: 'schemaTingkatKota',
      };

      const keyMasterInstrumen = this.$getDeepObj(this.meta, `lokakarya_kegiatan.${this.kKegiatan}.5`);
      if (this.schemaInstrumen[keyMasterInstrumen]) {
        return this.schemaInstrumen[keyMasterInstrumen];
      }

      if (mapSchema[this.kKegiatan]) {
        return this[mapSchema[this.kKegiatan]];
      }

      return {
        pelapor: [
          {
            type: 'textView',
            label: 'Nama Kegiatan',
            labelColor: 'grey',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            value: this.$getDeepObj(this.meta, `lokakarya_kegiatan.${this.kKegiatan}.0`) || '',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'textView',
            label: 'Nama Fasilitator',
            labelColor: 'grey',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            value: this.detail.pelapor || this.ptk.nama,
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'VDatePicker',
            name: 'tgl_pelaksanaan',
            label: 'Waktu Pelaksanaan',
            labelColor: 'grey',
            usePrependInnerIcon: 'mdi-calendar-month',
            hint: 'wajib diisi',
            required: true,
            outlined: true,
            singleLine: true,
            disabled: this.readOnly,
            hideDetails: true,
            dense: true,
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'lokasi',
            label: 'Tempat Pelaksanaan',
            labelColor: 'grey',
            hint: 'wajib diisi',
            outlined: true,
            singleLine: true,
            readonly: this.readOnly,
            hideDetails: true,
            dense: true,
            rules: { required: true, maxChar: 250 },
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            type: 'VSelect',
            name: 'k_lokakarya_moda_psp',
            label: 'Moda yang diterapkan',
            labelColor: 'grey',
            hint: 'wajib diisi',
            items: this.$mapForMaster(this.$getDeepObj(this, 'masters.lokakarya_moda_psp') || {}),
            required: true,
            outlined: true,
            singleLine: true,
            hideDetails: true,
            readonly: this.readOnly,
            dense: true,
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            exist: { status: !this.readOnly && [38, 58].includes(+this.kKegiatan) },
            type: 'VSelect',
            name: 'k_durasi_psp',
            label: 'Kolom JP yang Difasilitasi FSP',
            labelColor: 'grey',
            hint: 'wajib diisi',
            items: this.mKpOpsiPspDurasiPsp,
            required: true,
            outlined: true,
            singleLine: true,
            hideDetails: true,
            dense: true,
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            exist: { status: this.readOnly && [38, 58].includes(+this.kKegiatan) },
            type: 'textView',
            label: 'Kolom JP yang Difasilitasi FSP',
            labelColor: 'grey',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            value: this.$getDeepObj(this.detail, `m_kp_opsi_psp_durasi_psp.data.keterangan`) || '',
            grid: { cols: 12, md: 6 },
          },
          {
            exist: { status: ![38, 58].includes(+this.kKegiatan) },
            type: 'textView',
            label: 'Durasi (JP)',
            labelColor: 'grey',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            value: '8 JP',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'VRadio',
            name: 'k_teaching_psp',
            label: 'Bagaimana proses kegiatan kelompok tersebut dilaksanakan?',
            labelColor: 'grey',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            hint: 'wajib diisi',
            items: this.mKpOpsiPspTeachingPsp,
            required: true,
            hideDetails: false,
            outlined: true,
            dense: true,
            row: true,
            singleLine: false,
            grid: { cols: 12, md: 6 },
          },
        ],
        peserta: [
          {
            type: 'VTextField',
            name: 'jml_pa',
            label: 'Jumlah Fasilitator',
            labelColor: this.isNotEmpty && !this.form.jml_pa && this.form.jml_pa !== 0 ? 'red' : 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            hideDetail: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_pengawas',
            label: 'Jumlah Pengawas Sekolah',
            labelColor: this.isNotEmpty && !this.form.jml_pengawas && this.form.jml_pengawas !== 0 ? 'red' : 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_kasek',
            label: 'Jumlah Kepala Sekolah',
            labelColor: this.isNotEmpty && !this.form.jml_kasek && this.form.jml_kasek !== 0 ? 'red' : 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_peserta_tk',
            label: 'dari TK-PAUD',
            labelColor: this.isNotEmpty && !this.form.jml_peserta_tk && this.form.jml_peserta_tk !== 0 ? 'red' : 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_peserta_sd',
            label: 'dari SD',
            labelColor: this.isNotEmpty && !this.form.jml_peserta_sd && this.form.jml_peserta_sd !== 0 ? 'red' : 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_peserta_smp',
            label: 'dari SMP',
            labelColor:
              this.isNotEmpty && !this.form.jml_peserta_smp && this.form.jml_peserta_smp !== 0 ? 'red' : 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_peserta_sma',
            label: 'dari SMA',
            labelColor:
              this.isNotEmpty && !this.form.jml_peserta_sma && this.form.jml_peserta_sma !== 0 ? 'red' : 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_peserta_slb',
            label: 'dari SLB',
            labelColor:
              this.isNotEmpty && !this.form.jml_peserta_slb && this.form.jml_peserta_slb !== 0 ? 'red' : 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'textView',
            label: 'Total Peserta (Otomatis terisi dengan akumulasi semua data)',
            labelColor: 'grey',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            value:
              Number(this.form['jml_pa'] || 0) +
              Number(this.form['jml_pengawas']) +
              Number(this.form['jml_kasek']) +
              Number(this.form['jml_peserta_tk']) +
              Number(this.form['jml_peserta_sd']) +
              Number(this.form['jml_peserta_smp']) +
              Number(this.form['jml_peserta_sma']) +
              Number(this.form['jml_peserta_slb']),
            grid: { cols: 12, md: 3 },
          },
        ],
        deskripsi: [
          {
            type: 'VTextarea',
            name: 'efektif',
            label: 'Tuliskan hal-hal yang sudah berjalan dengan efektif',
            labelColor: 'grey',
            hint: '',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            rows: 4,
            autoGrow: true,
            grid: { cols: 12, md: 12, sm: 12 },
          },
          {
            type: 'VTextarea',
            name: 'peningkatan',
            label: 'Tuliskan hal-hal yang perlu ditingkatkan',
            labelColor: 'grey',
            hint: '',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            rows: 4,
            autoGrow: true,
            grid: { cols: 12, md: 12, sm: 12 },
          },
          {
            exist: { status: [32, 36].includes(+this.kKegiatan) },
            type: 'VTextarea',
            name: 'coaching_pengawas',
            label: 'Tuliskan Perkembangan Coaching Pengawas Sekolah ke Kepala Sekolah',
            labelColor: 'grey',
            hint: '',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            rows: 4,
            autoGrow: true,
            grid: { cols: 12, md: 12, sm: 12 },
          },
        ],
        berkas: [
          {
            kBerkas: 1,
            key: 'presensi-peserta',
            label: 'daftar hadir Peserta',
            berkases: this.lokakaryaBerkases.filter((s) => Number(s.k_lokakarya_berkas_psp) === 1) || [],
          },
          {
            kBerkas: 2,
            key: 'presensi-fasilitator',
            label: 'daftar hadir Fasilitator / Pengajar',
            berkases: this.lokakaryaBerkases.filter((s) => Number(s.k_lokakarya_berkas_psp) === 2) || [],
          },
          {
            kBerkas: 3,
            key: 'bukti-fisik',
            label: [38, 58].includes(+this.kKegiatan)
              ? 'Bukti Fisik Dokumen yang Relevan (tautan hasil sesi refleksi dan berbagi praktik baik; tautan hasil rencana dan tindak lanjut)'
              : 'bukti fisik dokumen yang relevan (jika ada)',
            berkases: this.lokakaryaBerkases.filter((s) => Number(s.k_lokakarya_berkas_psp) === 3) || [],
          },
          {
            kBerkas: 6,
            key: 'dokumentasi',
            label: 'dokumentasi kegiatan',
            desc: 'Sematkan minimal 3 Foto Dokumentasi dan maksimal 5 foto.',
            berkases: this.lokakaryaBerkases.filter((s) => Number(s.k_lokakarya_berkas_psp) === 6) || [],
          },
        ],
        meetings: [
          {
            type: 'VTextField',
            name: 'url_meeting',
            label: 'Rekaman Video Conference (jika ada) taruh URL, video rekaman disini',
            labelColor: 'grey',
            hint: '',
            required: true,
            grid: { cols: 12, md: 12, sm: 12 },
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readonly,
            prependInnerIcon: 'mdi-video',
          },
        ],
      };
    },

    schemaOrientasi() {
      return {
        pelapor: [
          {
            type: 'textView',
            label: 'Nama Kegiatan',
            labelColor: 'grey',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            value: this.$getDeepObj(this.meta, `lokakarya_kegiatan.${this.kKegiatan}.0`) || '',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'textView',
            label: 'Nama Fasilitator',
            labelColor: 'grey',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            value: this.detail.pelapor || this.ptk.nama,
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'VSelect',
            name: 'k_jenjang',
            label: 'Jenjang',
            labelColor: 'grey',
            hint: 'wajib diisi',
            items: this.mJenjang,
            itemText: 'text',
            itemValue: 'value',
            outlined: true,
            dense: true,
            singleLine: true,
            multiple: true,
            required: true,
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'VDatePicker',
            name: 'tgl_pelaksanaan',
            label: 'Waktu Pelaksanaan',
            labelColor: 'grey',
            usePrependInnerIcon: 'mdi-calendar-month',
            hint: 'wajib diisi',
            required: true,
            outlined: true,
            singleLine: true,
            disabled: this.readOnly,
            hideDetails: true,
            dense: true,
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            type: 'cascade',
            labelColor: 'grey',
            configs: this.configs,
            grid: { cols: 12 },
          },
          {
            type: 'VSelect',
            name: 'k_lokakarya_moda_psp',
            label: 'Moda yang diterapkan',
            labelColor: 'grey',
            hint: 'wajib diisi',
            items: this.$mapForMaster(this.$getDeepObj(this, 'masters.lokakarya_moda_psp') || {}),
            required: true,
            outlined: true,
            singleLine: true,
            readonly: this.readOnly,
            dense: true,
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            type: 'textView',
            label: 'Durasi (JP)',
            labelColor: 'grey',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            value: '4 JP',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'VRadio',
            name: 'k_teaching_psp',
            label: 'Bagaimana proses kegiatan kelompok tersebut dilaksanakan?',
            labelColor: 'grey',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            hint: 'wajib diisi',
            items: this.mKpOpsiPspTeachingPsp,
            required: true,
            hideDetails: false,
            outlined: true,
            dense: true,
            row: true,
            singleLine: false,
            grid: { cols: 12, md: 6 },
          },
        ],
        peserta: [
          {
            type: 'VTextField',
            name: 'jml_peserta',
            label: 'Jumlah peserta',
            labelColor: this.isNotEmpty && !this.form.jml_peserta && this.form.jml_peserta !== 0 ? 'red' : 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            hideDetail: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_peserta_absen',
            label: 'Jumlah peserta yang tidak hadir',
            labelColor:
              this.isNotEmpty && !this.form.jml_peserta_absen && this.form.jml_peserta_absen !== 0 ? 'red' : 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
        ],
        deskripsi: [
          {
            type: 'VTextarea',
            name: 'pengalaman',
            label: 'Tuliskan Pengalaman di Pendampingan Tahun Pertama',
            labelColor: this.isNotEmpty && !this.form.pengalaman ? 'red' : 'grey',
            placeholder: 'Tuliskan deskripsi antara 150 - 300 kata',
            hint: `150 - 300 kata`,
            counter: 300,
            counterValue: (v) => this.$wordCount(v),
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            rows: 4,
            autoGrow: true,
            grid: { cols: 12, md: 12, sm: 12 },
          },
          {
            type: 'VTextarea',
            name: 'kesepakatan',
            label: 'Tuliskan Kesepakatan untuk Pendampingan di Tahun Kedua antara Fasilitator dan Satuan Pendidikan',
            labelColor: this.isNotEmpty && !this.form.kesepakatan ? 'red' : 'grey',
            placeholder: 'Tuliskan deskripsi antara 150 - 300 kata',
            hint: `150 - 300 kata`,
            counter: 300,
            counterValue: (v) => this.$wordCount(v),
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            rows: 4,
            autoGrow: true,
            grid: { cols: 12, md: 12, sm: 12 },
          },
        ],
        berkas: [
          {
            kBerkas: 6,
            key: 'dokumentasi',
            label: 'dokumentasi kegiatan',
            desc: 'Sematkan minimal 3 Foto Dokumentasi dan maksimal 5 foto.',
            berkases: this.lokakaryaBerkases.filter((s) => Number(s.k_lokakarya_berkas_psp) === 6) || [],
          },
        ],
        meetings: [
          {
            type: 'VTextField',
            name: 'url_meeting',
            label: 'Rekaman Video Conference taruh URL, video rekaman disini',
            labelColor: 'grey',
            hint: '',
            required: true,
            grid: { cols: 12, md: 12, sm: 12 },
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readonly,
            prependInnerIcon: 'mdi-video',
          },
        ],
      };
    },

    schemaTingkatKota() {
      return {
        pelapor: [
          {
            type: 'textView',
            label: 'Nama Kegiatan',
            labelColor: 'grey',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            value: this.$getDeepObj(this.meta, `lokakarya_kegiatan.${this.kKegiatan}.0`) || '',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'textView',
            label: 'Nama Fasilitator',
            labelColor: 'grey',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            value: this.detail.pelapor || this.ptk.nama,
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'VDatePicker',
            name: 'tgl_pelaksanaan',
            label: 'Waktu Pelaksanaan',
            labelColor: 'grey',
            usePrependInnerIcon: 'mdi-calendar-month',
            hint: 'wajib diisi',
            required: true,
            outlined: true,
            singleLine: true,
            disabled: this.readOnly,
            hideDetails: true,
            dense: true,
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'lokasi',
            label: 'Tempat Pelaksanaan',
            labelColor: 'grey',
            hint: 'wajib diisi',
            outlined: true,
            singleLine: true,
            readonly: this.readOnly,
            hideDetails: true,
            dense: true,
            rules: { required: true, maxChar: 250 },
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            type: 'VSelect',
            name: 'k_lokakarya_moda_psp',
            label: 'Moda yang diterapkan',
            labelColor: 'grey',
            hint: 'wajib diisi',
            items: this.$mapForMaster(this.$getDeepObj(this, 'masters.lokakarya_moda_psp') || {}),
            required: true,
            outlined: true,
            singleLine: true,
            readonly: this.readOnly,
            dense: true,
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            exist: { status: !this.readOnly && [38, 58].includes(+this.kKegiatan) },
            type: 'VSelect',
            name: 'k_durasi_psp',
            label: 'Kolom JP yang Difasilitasi FSP',
            labelColor: 'grey',
            hint: 'wajib diisi',
            items: this.mKpOpsiPspDurasiPsp,
            required: true,
            outlined: true,
            singleLine: true,
            dense: true,
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            exist: { status: this.readOnly && [38, 58].includes(+this.kKegiatan) },
            type: 'textView',
            label: 'Kolom JP yang Difasilitasi FSP',
            labelColor: 'grey',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            value: this.$getDeepObj(this.detail, `m_kp_opsi_psp_durasi_psp.data.keterangan`) || '',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'VRadio',
            name: 'k_teaching_psp',
            label: 'Bagaimana proses kegiatan kelompok tersebut dilaksanakan?',
            labelColor: 'grey',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            hint: 'wajib diisi',
            items: this.mKpOpsiPspTeachingPsp,
            required: true,
            hideDetails: false,
            outlined: true,
            dense: true,
            row: true,
            singleLine: false,
            grid: { cols: 12, md: 6 },
          },
        ],
        peserta: [
          {
            type: 'VTextField',
            name: 'jml_pa',
            label: 'Jumlah Fasilitator',
            labelColor: this.isNotEmpty && !this.form.jml_pa && this.form.jml_pa !== 0 ? 'red' : 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_pengawas',
            label: 'Jumlah Pengawas Sekolah',
            labelColor: this.isNotEmpty && !this.form.jml_pengawas && this.form.jml_pengawas !== 0 ? 'red' : 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_kasek',
            label: 'Jumlah Kepala Sekolah',
            labelColor: this.isNotEmpty && !this.form.jml_kasek && this.form.jml_kasek !== 0 ? 'red' : 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_peserta_tk',
            label: 'dari TK-PAUD',
            labelColor: this.isNotEmpty && !this.form.jml_peserta_tk && this.form.jml_peserta_tk !== 0 ? 'red' : 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_peserta_sd',
            label: 'dari SD',
            labelColor: this.isNotEmpty && !this.form.jml_peserta_sd && this.form.jml_peserta_sd !== 0 ? 'red' : 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_peserta_smp',
            label: 'dari SMP',
            labelColor:
              this.isNotEmpty && !this.form.jml_peserta_smp && this.form.jml_peserta_smp !== 0 ? 'red' : 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_peserta_sma',
            label: 'dari SMA',
            labelColor:
              this.isNotEmpty && !this.form.jml_peserta_sma && this.form.jml_peserta_sma !== 0 ? 'red' : 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'VTextField',
            name: 'jml_peserta_slb',
            label: 'dari SLB',
            labelColor:
              this.isNotEmpty && !this.form.jml_peserta_slb && this.form.jml_peserta_slb !== 0 ? 'red' : 'grey',
            hint: '',
            mask: '###',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            grid: { cols: 12, md: 3, sm: 12 },
          },
          {
            type: 'textView',
            label: 'Jumlah Peserta (akumulasi semua data)',
            labelColor: 'grey',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            value:
              Number(this.form['jml_pa'] || 0) +
              Number(this.form['jml_pengawas'] || 0) +
              Number(this.form['jml_kasek'] || 0) +
              Number(this.form['jml_peserta_tk'] || 0) +
              Number(this.form['jml_peserta_sd'] || 0) +
              Number(this.form['jml_peserta_smp'] || 0) +
              Number(this.form['jml_peserta_sma'] || 0) +
              Number(this.form['jml_peserta_slb'] || 0),
            grid: { cols: 12, md: 3 },
          },
        ],
        deskripsi: [
          {
            type: 'VTextarea',
            name: 'efektif',
            label: 'Tuliskan hal-hal yang sudah berjalan dengan efektif',
            labelColor: this.isNotEmpty && !this.form.efektif ? 'red' : 'grey',
            hint: '',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            rows: 4,
            autoGrow: true,
            grid: { cols: 12, md: 12, sm: 12 },
          },
          {
            type: 'VTextarea',
            name: 'peningkatan',
            label: 'Tuliskan hal-hal yang perlu ditingkatkan',
            labelColor: this.isNotEmpty && !this.form.peningkatan ? 'red' : 'grey',
            hint: '',
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            rows: 4,
            autoGrow: true,
            grid: { cols: 12, md: 12, sm: 12 },
          },
        ],
        berkas: [
          {
            kBerkas: 1,
            key: 'presensi-peserta',
            label: 'daftar hadir Peserta',
            berkases: this.lokakaryaBerkases.filter((s) => Number(s.k_lokakarya_berkas_psp) === 1) || [],
          },
          {
            kBerkas: 2,
            key: 'presensi-fasilitator',
            label: 'daftar hadir Fasilitator / Pengajar',
            berkases: this.lokakaryaBerkases.filter((s) => Number(s.k_lokakarya_berkas_psp) === 2) || [],
          },
          {
            kBerkas: 3,
            key: 'bukti-fisik',
            label:
              'Bukti Fisik Dokumen yang Relevan (tautan hasil sesi refleksi dan berbagi praktik baik; tautan hasil rencana dan tindak lanjut)',
            berkases: this.lokakaryaBerkases.filter((s) => Number(s.k_lokakarya_berkas_psp) === 3) || [],
          },
          {
            kBerkas: 6,
            key: 'dokumentasi',
            label: 'dokumentasi kegiatan',
            desc: 'Sematkan minimal 3 Foto Dokumentasi dan maksimal 5 foto.',
            berkases: this.lokakaryaBerkases.filter((s) => Number(s.k_lokakarya_berkas_psp) === 6) || [],
          },
        ],
        meetings: [
          {
            type: 'VTextField',
            name: 'url_meeting',
            label: 'Rekaman Video Conference taruh URL, video rekaman disini',
            labelColor: 'grey',
            hint: '',
            required: true,
            grid: { cols: 12, md: 12, sm: 12 },
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readonly,
            prependInnerIcon: 'mdi-video',
          },
        ],
      };
    },

    schemaRefleksiCoaching() {
      return {
        pelapor: [
          {
            type: 'textView',
            label: 'Nama Kegiatan',
            labelColor: 'grey',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            value: this.$getDeepObj(this.meta, `lokakarya_kegiatan.${this.kKegiatan}.0`) || '',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'textView',
            label: 'Nama Fasilitator',
            labelColor: 'grey',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            value: this.detail.pelapor || this.ptk.nama,
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'VSelect',
            name: 'k_jenjang',
            label: 'Jenjang',
            labelColor: 'grey',
            hint: 'wajib diisi',
            items: this.mJenjang,
            itemText: 'text',
            itemValue: 'value',
            outlined: true,
            dense: true,
            singleLine: true,
            multiple: true,
            required: true,
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'VDatePicker',
            name: 'tgl_pelaksanaan',
            label: 'Waktu Pelaksanaan',
            labelColor: 'grey',
            usePrependInnerIcon: 'mdi-calendar-month',
            hint: 'wajib diisi',
            required: true,
            outlined: true,
            singleLine: true,
            disabled: this.readOnly,
            hideDetails: true,
            dense: true,
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            type: 'cascade',
            labelColor: 'grey',
            configs: this.configs,
            grid: { cols: 12 },
          },
          {
            type: 'VSelect',
            name: 'k_lokakarya_moda_psp',
            label: 'Moda yang diterapkan',
            labelColor: 'grey',
            hint: 'wajib diisi',
            items: this.$mapForMaster(this.$getDeepObj(this, 'masters.lokakarya_moda_psp') || {}),
            required: true,
            outlined: true,
            singleLine: true,
            readonly: this.readOnly,
            dense: true,
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            type: 'textView',
            label: 'Durasi (JP)',
            labelColor: 'grey',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            value: '3 JP',
            grid: { cols: 12, md: 6 },
          },
          {
            type: 'VRadio',
            name: 'k_teaching_psp',
            label: 'Bagaimana proses kegiatan kelompok tersebut dilaksanakan?',
            labelColor: 'grey',
            bgColor: 'grey lighten-3 pa-2 mb-4',
            hint: 'wajib diisi',
            items: this.mKpOpsiPspTeachingPsp,
            required: true,
            hideDetails: false,
            outlined: true,
            dense: true,
            row: true,
            singleLine: false,
            grid: { cols: 12, md: 6 },
          },
        ],
        peserta: [],
        deskripsi: [
          {
            type: 'VTextarea',
            name: 'pengawas_dengar',
            label: 'Tuliskan Perkembangan Pengawas Sekolah dalam Kemampuan Mendengar Aktif',
            labelColor: this.isNotEmpty && !this.form.pengawas_dengar ? 'red' : 'grey',
            placeholder: 'Tuliskan deskripsi antara 150 - 300 kata',
            hint: `150 - 300 kata`,
            counter: 300,
            counterValue: (v) => this.$wordCount(v),
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            rows: 4,
            autoGrow: true,
            grid: { cols: 12, md: 12, sm: 12 },
          },
          {
            type: 'VTextarea',
            name: 'pengawas_tanya',
            label: 'Tuliskan Perkembangan Pengawas Sekolah dalam Kemampuan Mengajukan Pertanyaan Berbobot',
            labelColor: this.isNotEmpty && !this.form.pengawas_tanya ? 'red' : 'grey',
            placeholder: 'Tuliskan deskripsi antara 150 - 300 kata',
            hint: `150 - 300 kata`,
            counter: 300,
            counterValue: (v) => this.$wordCount(v),
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            rows: 4,
            autoGrow: true,
            grid: { cols: 12, md: 12, sm: 12 },
          },
          {
            type: 'VTextarea',
            name: 'pengawas_coachee',
            label: 'Tuliskan Perkembangan Pengawas Sekolah dalam Kemampuan Memberdayakan Coachee',
            labelColor: this.isNotEmpty && !this.form.pengawas_coachee ? 'red' : 'grey',
            placeholder: 'Tuliskan deskripsi antara 150 - 300 kata',
            hint: `150 - 300 kata`,
            counter: 300,
            counterValue: (v) => this.$wordCount(v),
            required: false,
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readOnly,
            rows: 4,
            autoGrow: true,
            grid: { cols: 12, md: 12, sm: 12 },
          },
        ],
        berkas: [
          {
            kBerkas: 6,
            key: 'dokumentasi',
            label: 'dokumentasi kegiatan',
            desc: 'Sematkan minimal 3 Foto Dokumentasi dan maksimal 5 foto.',
            berkases: this.lokakaryaBerkases.filter((s) => Number(s.k_lokakarya_berkas_psp) === 6) || [],
          },
        ],
        meetings: [
          {
            type: 'VTextField',
            name: 'url_meeting',
            label: 'Rekaman Video Conference taruh URL, video rekaman disini',
            labelColor: 'grey',
            hint: '',
            required: true,
            grid: { cols: 12, md: 12, sm: 12 },
            outlined: true,
            singleLine: true,
            dense: true,
            readonly: this.readonly,
            prependInnerIcon: 'mdi-video',
          },
        ],
      };
    },
  },
};
